import React from 'react';

import './LoadingIcon.scss'


const LoadingIcon = () => <div className="loading-icon" />

export default LoadingIcon
